import { context, updateContextState } from "../../components/wr-context";
var fetchDecisionTreeFlows = function(catalogId) {
    catalogId = catalogId || context.constants.client.catalogIds[0];
    return {
        url: "".concat(context.constants.appHost, "/api/v1/service-catalogs/catalogs/catalog-id/").concat(catalogId, "/flows"),
        comparison: catalogId,
        method: "GET",
        then: function(param) {
            var flows = param.data;
            if (flows.length) {
                return fetchDecisionTreeFlowById(flows[0].flowId);
            } else {
                return {
                    value: null
                };
            }
        }
    };
};
var fetchDecisionTreeFlowById = function(flowId) {
    var shouldRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        url: "".concat(context.constants.appHost, "/api/v1/flows/search?type=guided-choice&id=").concat(flowId, "&full=true&populateOutcomeNames=true"),
        comparison: flowId,
        method: "GET",
        refreshing: shouldRefresh,
        force: shouldRefresh,
        then: function(param) {
            var flow = param.data;
            updateContextState(function(state) {
                state.flow = flow[0];
            });
            return {
                value: flow[0]
            };
        }
    };
};
export default {
    fetchDecisionTreeFlows: fetchDecisionTreeFlows,
    fetchDecisionTreeFlowById: fetchDecisionTreeFlowById
};
